import styled from 'styled-components';
import { StyledLinkButton } from '../../../common/components/Button/StyledButtons';
import { DisplayCard } from '../../../common/components/cards/DisplayCard/DisplayCard';
import {
  DisplayCardContainer,
  DisplayCardContent,
  DisplayCardFooter,
  DisplayCardHeader,
} from '../../../common/components/cards/DisplayCard/DisplayCard.styles';
import { HeImgix } from '../../../common/components/images/HeImgix';
import { Col, FLEX_COLS, FLEX_COL_TO_ROW, Row } from '../../../common/components/layout/FlexLayout';
import { PageSection } from '../../../common/components/layout/PageSection/PageSection';
import { HeColours } from '../../../common/styles/HeColours';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { Breakpoint, FontSize } from '../../../common/styles/constants';
import { Badge } from '../../../search/ResultView/ResultList/ProfileCards/search-card/Badges/Badge/Badge';

export const HomeInformationPageSection = styled(PageSection)`
  background-color: ${HeColours.gray[50]};
`;

export const HomeInformationCard = styled(DisplayCard)`
  ${DisplayCardFooter} {
    ${FLEX_COLS}

    ${StyledLinkButton} {
      width: 100%;
    }
  }

  ${Breakpoint.MEDIUM} {
    ${DisplayCardContainer} {
      flex-flow: wrap;
    }

    ${DisplayCardHeader} {
      flex: 100%;
    }
    ${DisplayCardContent} {
      margin-bottom: 0;
      width: 50%;
    }

    ${DisplayCardFooter} {
      align-items: flex-end;
      margin-left: auto;

      ${StyledLinkButton} {
        width: auto;
        margin-bottom: 0;
      }
    }
  }

  ${Breakpoint.LARGE} {
    ${DisplayCardContainer} {
      flex-flow: column;
    }

    ${DisplayCardHeader} {
      flex: initial;
    }

    ${DisplayCardContent} {
      margin-bottom: initial;
      width: auto;
    }

    ${DisplayCardFooter} {
      align-items: flex-start;
      margin-left: 0;
      width: auto;
    }
  }
`;

export const HomeInformationRow = styled(Row)`
  ${FLEX_COL_TO_ROW(Breakpoint.LARGE)}

  ${Col} {
    margin-bottom: 24px;
  }
`;

export const CardIcon = styled(HeImgix)`
  height: 30px;
  width: 30px;
`;

export const TrendingBadge = styled(Badge)`
  background-color: ${ThemeColours.accent100};
  color: ${ThemeColours.accent700};
  font-size: ${FontSize.EXTRA_SMALL};
  text-transform: capitalize;
`;
